import React, { useRef } from 'react'
import { Script } from 'gatsby'

const OwensCorning = () => {
  const ref = useRef()
  return (
    <div
      // eslint-disable-next-line no-return-assign
      ref={ref}
      id="visualizer"
      style={{ paddingTop: '1rem' }}
      data-zip="21230"
    >
      <Script
        id="owens-corning-script"
        dangerouslySetInnerHTML={{
          __html: `const deqDiv = document.getElementById('visualizer')
    const deqZip = deqDiv.getAttribute('data-zip')
    const widget = new deq({
    target: '#visualizer',
    zip: deqZip,
    });`,
        }}
      />
    </div>
  )
}

export default OwensCorning
